import React, { useContext, useEffect, useState } from 'react'

import { Container, Grid } from '@material-ui/core'

import moment from 'moment'
import ParserComments from './Helpers/ParserComents'
import ParserGraphData from './Helpers/ParserGraphData'

import Context from '../../context'
import { checkPageAccess, getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

import DashboardCalendar from '../../components/Calendar'
import VerticalBar from './Charts/VerticalBar'
import DashboardComments from './DashboardComments'

import { getDashData } from '../../services/ReportsApi'
import DayAccess from './DayAccess'
import UsersImages from './UsersImages'
import useStyles from './styles'

export default function Dashboard() {
  const classes = useStyles()
  const { user, setUser, setAboutCurrentPage, screenList, setScreenList, rangeDate, setRangeDate } =
    useContext(Context)

  const [isLoading, setIsLoading] = useState(true)
  const [graphData, setGraphData] = useState([])
  const [futureGraphData, setFutureGraphData] = useState([])
  const [validationsList, setValidationsList] = useState([])
  const [publicCommentList, setPublicCommentList] = useState([])
  const [privateCommentList, setPrivateCommentList] = useState([])
  const [usersImagesList, setUsersImagesList] = useState([])
  const [showData, setShowData] = useState(false)

  const updateData = () => {
    setIsLoading(true)
    getDashData(
      undefined,
      moment(rangeDate[0]).format('YYYY-MM-DD').toString(),
      moment(rangeDate[1]).format('YYYY-MM-DD').toString()
    ).then(r => {
      if (r) {
        const { dataGraphUse, validations, usersImage } = r

        setGraphData(ParserGraphData('less', dataGraphUse))
        setFutureGraphData(ParserGraphData('great', dataGraphUse))

        setValidationsList(validations)

        setPublicCommentList(ParserComments('publicComment', validations))
        setPrivateCommentList(ParserComments('privateComment', validations))

        setUsersImagesList(usersImage)

        setIsLoading(false)
        setShowData(true)
      } else {
        console.log('erro ao trazer dados')
      }
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Dashboard',
      buttons: null
    })
    updateData()
  }, [])

  useEffect(() => {
    updateData()
  }, [rangeDate])

  useEffect(() => {
    const pageAccess = checkPageAccess()
    if (pageAccess) {
      history.replace(pageAccess)
    }
  }, [user])
  const compareRoleGroups = ![2, 4, 6].includes(user?.userGroup)
  return (
    <Container maxWidth="xl">
      <Context.Provider
        value={{
          user,
          setUser,
          rangeDate,
          setRangeDate,
          screenList,
          setScreenList,
          graphData,
          futureGraphData,
          isLoading,
          validationsList,
          publicCommentList,
          privateCommentList,
          usersImagesList,
          setUsersImagesList
        }}
      >
        {compareRoleGroups && (
          <Grid container spacing={2}>
            {showData ? (
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={4}
                  className={classes.graphArea}
                  style={{ marginBottom: '25px', marginTop: '15px' }}
                >
                  <Grid item xs={8}>
                    <VerticalBar />
                  </Grid>
                  <Grid item xs={4}>
                    <DashboardCalendar />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <DashboardComments />
                </Grid>
                <Grid container spacing={2} style={{ marginBottom: '30px' }}>
                  <Grid item xs={2} className={classes.dayAccessArea}>
                    <DayAccess />
                  </Grid>
                  <Grid item xs={10} className={classes.photosArea}>
                    <UsersImages />
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={12}>
                Buscando dados para gerar os gráficos.
              </Grid>
            )}
          </Grid>
        )}
      </Context.Provider>
    </Container>
  )
}
